import { render } from "./aiTitle.vue?vue&type=template&id=1eb098b8"
import script from "./aiTitle.vue?vue&type=script&lang=js"
export * from "./aiTitle.vue?vue&type=script&lang=js"

import "./aiTitle.vue?vue&type=style&index=0&id=1eb098b8&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__